export function NoneButton({
  label,
  onClick
}: {
  label: string
  onClick: () => void
}) {
  return (
    <button
      type='button'
      onClick={onClick}
      className='mt-4 w-full cursor-pointer rounded-xl border border-dashed border-accent bg-page px-4 py-3 text-[13px] font-medium text-ink-soft transition-colors hover:bg-accent-light/40 hover:text-ink'
    >
      {label}
    </button>
  )
}
